export default __webpack_public_path__ + "8ef9105426364f9cd5ed32cd5646850d.png";